import { ref } from 'vue'

export const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'en', label: 'English',  flag: '🇬🇧' },
  { code: 'es', label: 'Español',  flag: '🇪🇸' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'de', label: 'Deutsch',  flag: '🇩🇪' },
  { code: 'ja', label: '日本語',    flag: '🇯🇵' },
  { code: 'zh', label: '中文',      flag: '🇨🇳' },
]

// ── Catégories de plats (label court + titre de bannière "titre + titreEm") ────
const CATEGORIES = {
  entrees: {
    fr: { label: 'Entrées', title: 'Nos', titleEm: 'Entrées' },
    en: { label: 'Starters', title: 'Our', titleEm: 'Starters' },
    es: { label: 'Entrantes', title: 'Nuestros', titleEm: 'Entrantes' },
    it: { label: 'Antipasti', title: 'I Nostri', titleEm: 'Antipasti' },
    de: { label: 'Vorspeisen', title: 'Unsere', titleEm: 'Vorspeisen' },
    ja: { label: '前菜', title: '当店の', titleEm: '前菜' },
    zh: { label: '前菜', title: '我们的', titleEm: '前菜' },
  },
  sushi: {
    fr: { label: 'Sushis', title: 'Nos', titleEm: 'Sushis' },
    en: { label: 'Sushi', title: 'Our', titleEm: 'Sushi' },
    es: { label: 'Sushis', title: 'Nuestros', titleEm: 'Sushis' },
    it: { label: 'Sushi', title: 'I Nostri', titleEm: 'Sushi' },
    de: { label: 'Sushi', title: 'Unser', titleEm: 'Sushi' },
    ja: { label: '寿司', title: '当店の', titleEm: '寿司' },
    zh: { label: '寿司', title: '我们的', titleEm: '寿司' },
  },
  maki: {
    fr: { label: 'Makis', title: 'Nos', titleEm: 'Makis' },
    en: { label: 'Maki Rolls', title: 'Our', titleEm: 'Maki Rolls' },
    es: { label: 'Makis', title: 'Nuestros', titleEm: 'Makis' },
    it: { label: 'Maki', title: 'I Nostri', titleEm: 'Maki' },
    de: { label: 'Maki-Rollen', title: 'Unsere', titleEm: 'Maki-Rollen' },
    ja: { label: '巻き寿司', title: '当店の', titleEm: '巻き寿司' },
    zh: { label: '卷寿司', title: '我们的', titleEm: '卷寿司' },
  },
  yakitori: {
    fr: { label: 'Yakitoris', title: 'Nos', titleEm: 'Yakitoris' },
    en: { label: 'Yakitori', title: 'Our', titleEm: 'Yakitori' },
    es: { label: 'Yakitoris', title: 'Nuestros', titleEm: 'Yakitoris' },
    it: { label: 'Yakitori', title: 'I Nostri', titleEm: 'Yakitori' },
    de: { label: 'Yakitori-Spieße', title: 'Unsere', titleEm: 'Yakitori-Spieße' },
    ja: { label: '焼き鳥', title: '当店の', titleEm: '焼き鳥' },
    zh: { label: '烤鸡串', title: '我们的', titleEm: '烤鸡串' },
  },
  california: {
    fr: { label: 'California', title: 'California', titleEm: 'Rolls' },
    en: { label: 'California', title: 'California', titleEm: 'Rolls' },
    es: { label: 'California', title: 'California', titleEm: 'Rolls' },
    it: { label: 'California', title: 'California', titleEm: 'Rolls' },
    de: { label: 'California', title: 'California', titleEm: 'Rolls' },
    ja: { label: 'カリフォルニア', title: 'カリフォルニア', titleEm: 'ロール' },
    zh: { label: '加州卷', title: '加州', titleEm: '卷' },
  },
  californiaMasago: {
    fr: { label: 'Masago', title: 'California', titleEm: 'Masago' },
    en: { label: 'Masago', title: 'California', titleEm: 'Masago' },
    es: { label: 'Masago', title: 'California', titleEm: 'Masago' },
    it: { label: 'Masago', title: 'California', titleEm: 'Masago' },
    de: { label: 'Masago', title: 'California', titleEm: 'Masago' },
    ja: { label: 'マサゴ', title: 'カリフォルニア', titleEm: 'マサゴ' },
    zh: { label: '飞鱼籽', title: '加州', titleEm: '飞鱼籽' },
  },
  californiaCroquant: {
    fr: { label: 'Croquant', title: 'California', titleEm: 'Croquant' },
    en: { label: 'Crispy', title: 'California', titleEm: 'Crispy' },
    es: { label: 'Crujiente', title: 'California', titleEm: 'Crujiente' },
    it: { label: 'Croccante', title: 'California', titleEm: 'Croccante' },
    de: { label: 'Knusprig', title: 'California', titleEm: 'Knusprig' },
    ja: { label: 'クリスピー', title: 'カリフォルニア', titleEm: 'クリスピー' },
    zh: { label: '香脆', title: '加州', titleEm: '香脆' },
  },
  sashimi: {
    fr: { label: 'Sashimis', title: 'Nos', titleEm: 'Sashimis' },
    en: { label: 'Sashimi', title: 'Our', titleEm: 'Sashimi' },
    es: { label: 'Sashimis', title: 'Nuestros', titleEm: 'Sashimis' },
    it: { label: 'Sashimi', title: 'I Nostri', titleEm: 'Sashimi' },
    de: { label: 'Sashimi', title: 'Unser', titleEm: 'Sashimi' },
    ja: { label: '刺身', title: '当店の', titleEm: '刺身' },
    zh: { label: '刺身', title: '我们的', titleEm: '刺身' },
  },
  temaki: {
    fr: { label: 'Temakis', title: 'Nos', titleEm: 'Temakis' },
    en: { label: 'Temaki', title: 'Our', titleEm: 'Temaki' },
    es: { label: 'Temakis', title: 'Nuestros', titleEm: 'Temakis' },
    it: { label: 'Temaki', title: 'I Nostri', titleEm: 'Temaki' },
    de: { label: 'Temaki', title: 'Unsere', titleEm: 'Temaki' },
    ja: { label: '手巻き', title: '当店の', titleEm: '手巻き' },
    zh: { label: '手卷', title: '我们的', titleEm: '手卷' },
  },
  onigiri: {
    fr: { label: 'Onigiris', title: 'Nos', titleEm: 'Onigiris' },
    en: { label: 'Onigiri', title: 'Our', titleEm: 'Onigiri' },
    es: { label: 'Onigiris', title: 'Nuestros', titleEm: 'Onigiris' },
    it: { label: 'Onigiri', title: 'I Nostri', titleEm: 'Onigiri' },
    de: { label: 'Onigiri', title: 'Unsere', titleEm: 'Onigiri' },
    ja: { label: 'おにぎり', title: '当店の', titleEm: 'おにぎり' },
    zh: { label: '饭团', title: '我们的', titleEm: '饭团' },
  },
  'spécialités': {
    fr: { label: 'Spécialités', title: 'Nos', titleEm: 'Spécialités' },
    en: { label: 'Specialties', title: 'Our', titleEm: 'Specialties' },
    es: { label: 'Especialidades', title: 'Nuestras', titleEm: 'Especialidades' },
    it: { label: 'Specialità', title: 'Le Nostre', titleEm: 'Specialità' },
    de: { label: 'Spezialitäten', title: 'Unsere', titleEm: 'Spezialitäten' },
    ja: { label: '特製料理', title: '当店の', titleEm: '特製料理' },
    zh: { label: '特色料理', title: '我们的', titleEm: '特色料理' },
  },
  plats: {
    fr: { label: 'Plats', title: 'Nos', titleEm: 'Plats' },
    en: { label: 'Dishes', title: 'Our', titleEm: 'Dishes' },
    es: { label: 'Platos', title: 'Nuestros', titleEm: 'Platos' },
    it: { label: 'Piatti', title: 'I Nostri', titleEm: 'Piatti' },
    de: { label: 'Gerichte', title: 'Unsere', titleEm: 'Gerichte' },
    ja: { label: '料理', title: '当店の', titleEm: '料理' },
    zh: { label: '菜肴', title: '我们的', titleEm: '菜肴' },
  },
  plateau: {
    fr: { label: 'Plateau', title: 'Nos', titleEm: 'Plateaux' },
    en: { label: 'Platter', title: 'Our', titleEm: 'Platters' },
    es: { label: 'Bandeja', title: 'Nuestras', titleEm: 'Bandejas' },
    it: { label: 'Piatto misto', title: 'I Nostri', titleEm: 'Piatti misti' },
    de: { label: 'Platte', title: 'Unsere', titleEm: 'Platten' },
    ja: { label: '盛り合わせ', title: '当店の', titleEm: '盛り合わせ' },
    zh: { label: '拼盘', title: '我们的', titleEm: '拼盘' },
  },
  MenuMidi: {
    fr: { label: 'Midi Express', title: 'Menu', titleEm: 'Midi Express' },
    en: { label: 'Lunch Express', title: 'Menu', titleEm: 'Lunch Express' },
    es: { label: 'Almuerzo Express', title: 'Menú', titleEm: 'Almuerzo Express' },
    it: { label: 'Pranzo Express', title: 'Menu', titleEm: 'Pranzo Express' },
    de: { label: 'Mittags-Express', title: 'Menü', titleEm: 'Mittags-Express' },
    ja: { label: 'ランチセット', title: 'メニュー', titleEm: 'ランチセット' },
    zh: { label: '午市套餐', title: '套餐', titleEm: '午市套餐' },
  },
  MakiSushi: {
    fr: { label: 'Makis & Sushis', title: 'Menu', titleEm: 'Makis & Sushis' },
    en: { label: 'Makis & Sushi', title: 'Menu', titleEm: 'Makis & Sushi' },
    es: { label: 'Makis y Sushis', title: 'Menú', titleEm: 'Makis y Sushis' },
    it: { label: 'Maki e Sushi', title: 'Menu', titleEm: 'Maki e Sushi' },
    de: { label: 'Maki & Sushi', title: 'Menü', titleEm: 'Maki & Sushi' },
    ja: { label: '巻き寿司と寿司', title: 'メニュー', titleEm: '巻き寿司と寿司' },
    zh: { label: '卷寿司和寿司', title: '套餐', titleEm: '卷寿司和寿司' },
  },
  mixtes: {
    fr: { label: 'Mixtes', title: 'Menu', titleEm: 'Mixte' },
    en: { label: 'Mixed', title: 'Menu', titleEm: 'Mixed' },
    es: { label: 'Mixtos', title: 'Menú', titleEm: 'Mixto' },
    it: { label: 'Misti', title: 'Menu', titleEm: 'Misto' },
    de: { label: 'Gemischt', title: 'Menü', titleEm: 'Gemischt' },
    ja: { label: 'ミックス', title: 'メニュー', titleEm: 'ミックス' },
    zh: { label: '综合', title: '套餐', titleEm: '综合' },
  },
  SashimisVaries: {
    fr: { label: 'Sashimis Variés', title: 'Sashimis', titleEm: 'Variés' },
    en: { label: 'Assorted Sashimi', title: 'Sashimi', titleEm: 'Assorted' },
    es: { label: 'Sashimis Variados', title: 'Sashimis', titleEm: 'Variados' },
    it: { label: 'Sashimi Misti', title: 'Sashimi', titleEm: 'Misti' },
    de: { label: 'Gemischtes Sashimi', title: 'Sashimi', titleEm: 'Gemischt' },
    ja: { label: '刺身盛り合わせ', title: '刺身', titleEm: '盛り合わせ' },
    zh: { label: '综合刺身', title: '刺身', titleEm: '拼盘' },
  },
  Chirashi: {
    fr: { label: 'Chirashis', title: 'Nos', titleEm: 'Chirashis' },
    en: { label: 'Chirashi', title: 'Our', titleEm: 'Chirashi' },
    es: { label: 'Chirashis', title: 'Nuestros', titleEm: 'Chirashis' },
    it: { label: 'Chirashi', title: 'I Nostri', titleEm: 'Chirashi' },
    de: { label: 'Chirashi', title: 'Unsere', titleEm: 'Chirashi' },
    ja: { label: 'ちらし寿司', title: '当店の', titleEm: 'ちらし寿司' },
    zh: { label: '散寿司', title: '我们的', titleEm: '散寿司' },
  },
  Duo: {
    fr: { label: 'Duo', title: 'Menu', titleEm: 'Duo' },
    en: { label: 'Duo', title: 'Menu', titleEm: 'Duo' },
    es: { label: 'Dúo', title: 'Menú', titleEm: 'Dúo' },
    it: { label: 'Duo', title: 'Menu', titleEm: 'Duo' },
    de: { label: 'Duo', title: 'Menü', titleEm: 'Duo' },
    ja: { label: 'デュオ', title: 'メニュー', titleEm: 'デュオ' },
    zh: { label: '双人套餐', title: '套餐', titleEm: '双人套餐' },
  },
  Bento: {
    fr: { label: 'Bentos', title: 'Nos', titleEm: 'Bentos' },
    en: { label: 'Bento', title: 'Our', titleEm: 'Bento' },
    es: { label: 'Bentos', title: 'Nuestros', titleEm: 'Bentos' },
    it: { label: 'Bento', title: 'I Nostri', titleEm: 'Bento' },
    de: { label: 'Bento-Boxen', title: 'Unsere', titleEm: 'Bento-Boxen' },
    ja: { label: '弁当', title: '当店の', titleEm: '弁当' },
    zh: { label: '便当', title: '我们的', titleEm: '便当' },
  },
  Brochettes: {
    fr: { label: 'Brochettes', title: 'Brochettes &', titleEm: 'Sushis' },
    en: { label: 'Skewers', title: 'Skewers &', titleEm: 'Sushi' },
    es: { label: 'Brochetas', title: 'Brochetas y', titleEm: 'Sushis' },
    it: { label: 'Spiedini', title: 'Spiedini e', titleEm: 'Sushi' },
    de: { label: 'Spieße', title: 'Spieße &', titleEm: 'Sushi' },
    ja: { label: '串焼き', title: '串焼き＆', titleEm: '寿司' },
    zh: { label: '烤串', title: '烤串和', titleEm: '寿司' },
  },
  menus: {
    fr: { label: 'Menus', title: 'Nos', titleEm: 'Menus' },
    en: { label: 'Menus', title: 'Our', titleEm: 'Menus' },
    es: { label: 'Menús', title: 'Nuestros', titleEm: 'Menús' },
    it: { label: 'Menu', title: 'I Nostri', titleEm: 'Menu' },
    de: { label: 'Menüs', title: 'Unsere', titleEm: 'Menüs' },
    ja: { label: 'メニュー', title: '当店の', titleEm: 'メニュー' },
    zh: { label: '套餐', title: '我们的', titleEm: '套餐' },
  },
}

// ── Chaînes de l'interface ──────────────────────────────────────────────────
const translations = {
  fr: {
    nav_home: 'Accueil',
    nav_menu: 'Le Menu',
    nav_infos: 'Infos',
    nav_reservation: 'Réservation',
    nav_notre_carte: 'Notre carte',
    nav_plats_a_la_carte: 'Plats à la carte',
    nav_menus_formules: 'Menus & Formules',
    nav_no_product: 'Aucun produit dans cette catégorie.',
    flyer_enter_site: 'Entrer sur le site',
    tagline_restaurant: 'restaurant japonais · albi',

    hero_intro: "Venez découvrir au coeur du centre-ville d'Albi",
    hero_title_line1: 'nos Sushis, nos Sashimis,',
    hero_title_line2: 'nos Yakitoris, et autres spécialités japonaises',
    hero_reservation_link: 'Réservation',

    footer_desc: "Une cuisine japonaise authentique au cœur d'Albi, préparée avec des produits frais sélectionnés chaque jour.",
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'Vente à emporter',
    footer_hours_label: 'Horaires',
    footer_days_tue_thu: 'Mardi – Jeudi',
    footer_days_fri: 'Vendredi',
    footer_days_sat: 'Samedi',
    footer_days_sun_mon: 'Dimanche – Lundi',
    footer_closed: 'Fermé',
    footer_alert_closed_lunch: 'Fermé vendredi et samedi midi',
    footer_note_hours: 'Horaires susceptibles de changer pendant les périodes scolaires et jours fériés.',
    footer_contact_label: 'Contact',
    footer_legal_label: 'Informations légales',
    footer_link_mentions: 'Mentions légales',
    footer_link_confidentialite: 'Politique de confidentialité',
    footer_link_cookies: 'Liens hypertextes et cookies',
    footer_link_espace_prive: 'Espace privé',
    footer_copyright: '© {year} Bamboo Sushi – Restaurant japonais à Albi. Tous droits réservés.',
    footer_bar_confidentialite: 'Confidentialité',
    footer_bar_cookies: 'Cookies',

    b3_eyebrow_find_us: 'Où nous trouver',
    b3_title_info: 'Informations',
    b3_title_info_em: 'Restaurant',
    b3_follow_us: 'Suivez-nous',
    b3_takeaway: 'À emporter',
    b3_address_label: 'Adresse',
    b3_hours_label: 'Horaires',
    b3_days_open: 'Du mardi au samedi',
    b3_lunch: 'Déjeuner',
    b3_dinner: 'Dîner',
    b3_eyebrow_clients: 'Nos clients parlent',
    b3_title_avis: 'Avis',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Basé sur 441 avis Google',
    b3_review1_text: "Toujours un plaisir de venir ici ! Jamais déçue : la fraîcheur, la propreté, la gentillesse de l'équipe… tout est parfait. Le meilleur restaurant de sushis du coin, sans hésiter.",
    b3_review1_date: 'Il y a 7 mois',
    b3_review2_text: 'Jamais déçu de la qualité de poisson. Si vous ne savez pas quoi commander, je vous conseille le Bento. Vous avez plusieurs plats très bons.',
    b3_review2_date: 'Il y a 2 ans',
    b3_review3_text: 'Les ramen (à emporter) sont excellents ! La spécificité du California Espadon est top ! Le rapport qualité prix est vraiment remarquable, je recommande à 100%.',
    b3_review3_date: 'Il y a un an',

    b5_quote: '« Chaque plat est une <em>intention</em> — un équilibre entre <em>nos produits frais</em>, la <em>générosité</em> de nos portions et la finesse de <em>nos saveurs</em>. »',
    b5_stat1_label: 'Poisson frais · arrivage quotidien',
    b5_stat2_label: "Années d'expérience",
    b5_stat3_label: 'Créations au menu',
    b5_stat4_label: 'Note Google · 441 avis',
    b5_prev: 'Précédent',
    b5_next: 'Suivant',
    b5_slide1_label: 'Dragon Roll',
    b5_slide2_label: 'Spider Roll',
    b5_slide3_label: 'Rainbow Roll',
    b5_slide4_label: 'Volcano Roll',
    b5_slide5_label: 'Tropical Roll',
    b5_slide6_label: 'California Saumon Avocat',
    b5_slide7_label: 'Saumon, Avocat, Kiri',
    b5_slide8_label: 'Assortiment Chirashis',

    res_eyebrow: 'Réserver',
    res_title: 'Réserver',
    res_title_em: 'une table',
    res_label_nom: 'Nom',
    res_placeholder_nom: 'Votre nom',
    res_label_personnes: 'Nombre de personnes',
    res_placeholder_personnes: 'ex : 2',
    res_label_date: 'Date souhaitée',
    res_hint_days: 'Ouvert mar. — sam. · Fermé dim. & lun.',
    res_ferme_warn: 'Le restaurant est fermé ce jour — veuillez choisir un autre jour.',
    res_label_heure: 'Heure souhaitée',
    res_choose_heure: 'Choisissez une heure',
    res_note_required: "Les champs marqués d'une <strong>*</strong> doivent être remplis avant l'envoi de la réservation",
    res_label_message: 'Message',
    res_placeholder_message: 'Ex : allergie, événement spécial, chaise enfant...',
    res_btn_sms: 'Envoyer la réservation par SMS',
    res_alert_fields_required: 'Veuillez remplir tous les champs obligatoires.',
    res_alert_closed_day: 'Le restaurant est fermé le dimanche et le lundi. Veuillez choisir une autre date.',

    menu_nav_plats: 'Plats à la carte',
    menu_nav_menus: 'Menus & Formules',
    menu_nav_reservation: 'Réservation',
    menu_banner_pre: 'Notre',
    menu_banner_em: 'Menu',
    menu_loading: 'Chargement du menu…',
    menu_ref_singular: 'référence',
    menu_ref_plural: 'références',
    menu_miso_note: "Tous les menus sont accompagnés d'une salade de chou et d'une Miso soupe",
    menu_empty_state: 'Aucun plat dans cette catégorie pour le moment.',
    menu_bottom_plats: 'Plats',
    menu_bottom_menus: 'Menus',
    menu_bottom_menu: 'Menu',
    menu_bottom_reserver: 'Réserver',
    menu_bottom_call: 'Appeler',
    menu_home_title: 'Accueil',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · Mardi–Samedi',

    plats_banner_default: 'Plats à la carte',
    plats_banner_fallback: 'Notre Carte',
    menus_banner_default: 'Menus',
    menus_banner_fallback: 'Notre Carte',
    california_banner_default: 'California',

    fav_back: '← Retour à la carte',
    fav_title: 'Vos Favoris',
    fav_empty: "Aucun produit favori pour le moment. N'hésitez pas à remplir vos favoris en cliquant sur vos plats préférés. Vous pouvez désélectionner en cliquant de nouveau dessus.",

    conn_title: 'Connexion',
    conn_email_ph: 'Adresse e‑mail',
    conn_password_ph: 'Mot de passe',
    conn_btn_login: 'Se connecter',
    conn_error: 'Identifiants invalides.',
    conn_btn_home: 'Accueil',

    info_eyebrow: 'Information',

    legal_title: 'Mentions Légales',
    legal_s1_title: '1 - Édition du site',
    legal_s1_intro: "En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique, il est précisé aux utilisateurs du site internet <strong>https://www.bamboosushi.fr/</strong> l'identité des différents intervenants dans le cadre de sa réalisation et de son suivi :",
    legal_s1_li_owner: '<strong>Propriétaire :</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>Contact :</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>Adresse :</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI',
    legal_s1_li_id: '<strong>Identification :</strong> SARL au capital social de 3 500 € – SIREN : 509 081 790 – RCS : Albi B 509 081 790',
    legal_s1_li_director: '<strong>Directeur de la publication :</strong> M. Samphal Buth',
    legal_s1_li_host: '<strong>Hébergeur :</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA',
    legal_s2_title: '2 - Propriété intellectuelle et contrefaçons',
    legal_s2_p: "SARL BAMBOO SUSHI est propriétaire des droits de propriété intellectuelle et détient les droits d'usage sur tous les éléments accessibles sur le site (textes, images, graphismes, logos, vidéos, architecture, icônes, sons). Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site est interdite sans autorisation écrite préalable. Toute exploitation non autorisée sera considérée comme une contrefaçon et poursuivie conformément aux articles L.335-2 et suivants du Code de la propriété intellectuelle.",
    legal_s3_title: '3 - Limitations de responsabilité',
    legal_s3_p: "SARL BAMBOO SUSHI ne pourra être tenue responsable des dommages directs ou indirects causés au matériel de l'utilisateur lors de l'accès au site. Elle décline toute responsabilité quant à l'utilisation des informations présentes. Des espaces interactifs peuvent être modérés. En cas de contenu illégal, l'entreprise se réserve le droit de supprimer sans préavis et de poursuivre les auteurs.",
    legal_s4_title: '4 - CNIL et gestion des données personnelles',
    legal_s4_p1: "Le site ne collecte des informations personnelles que via les formulaires que l'utilisateur est libre de remplir. Les données ne seront utilisées qu'avec votre consentement, pour vous adresser des courriers, devis ou informations.",
    legal_s4_p2: "Conformément à la loi Informatique et Libertés n° 78-17 du 6 janvier 1978 et au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition sur simple demande à : BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI.",
    legal_s4_p3: 'Des analyses statistiques peuvent être effectuées sur des données anonymisées à des fins de mesure de fréquentation.',
    legal_s5_title: '5 - Liens hypertextes et cookies',
    legal_s5_p: "Le site peut contenir des liens vers d'autres sites. BAMBOO SUSHI décline toute responsabilité quant à ces contenus externes. Lors de la navigation, des cookies peuvent être installés sur votre ordinateur. Ces cookies permettent uniquement des mesures statistiques et ne stockent pas d'information personnelle sans votre consentement. Vous pouvez refuser les cookies via les paramètres de votre navigateur. Les cookies sont conservés pour une durée maximale de 13 mois.",
    legal_s6_title: '6 - Droit applicable et attribution de juridiction',
    legal_s6_p: "Tout litige en lien avec l'utilisation du site <strong>https://www.bamboosushi.fr/</strong> est soumis au droit français. En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de Albi.",
    legal_s7_title: '7 - Politique de confidentialité',
    legal_s7_intro: "BAMBOO SUSHI attache une grande importance à la protection de vos données personnelles et au respect de votre vie privée, conformément au Règlement Général sur la Protection des Données (RGPD) en vigueur depuis le 25 mai 2018.",
    legal_s7_collecte_label: 'Collecte des données personnelles :',
    legal_s7_collecte_text: "Les données personnelles que vous pouvez transmettre sur notre site (formulaires, espace client, prise de contact) sont utilisées uniquement dans le cadre des services proposés par BAMBOO SUSHI. Elles ne sont ni revendues ni transmises à des tiers sans votre consentement explicite.",
    legal_s7_finalites_label: 'Finalités de traitement :',
    legal_s7_finalites_text: 'Ces données sont collectées pour :',
    legal_s7_finalites_li1: 'vous contacter suite à une demande ou une commande,',
    legal_s7_finalites_li2: 'gérer votre compte client,',
    legal_s7_finalites_li3: 'vous informer sur nos actualités si vous avez donné votre accord,',
    legal_s7_finalites_li4: 'garantir le bon fonctionnement des services du site.',
    legal_s7_conservation_label: 'Conservation des données :',
    legal_s7_conservation_text: "Les données sont conservées pour la durée nécessaire aux finalités pour lesquelles elles sont collectées, dans le respect de la réglementation en vigueur.",
    legal_s7_droits_label: 'Vos droits :',
    legal_s7_droits_text: "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression, de portabilité de vos données, ainsi que d'un droit d'opposition ou de limitation du traitement. Pour exercer ces droits, contactez-nous à :",
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI',
  },

  en: {
    nav_home: 'Home',
    nav_menu: 'The Menu',
    nav_infos: 'Info',
    nav_reservation: 'Reservation',
    nav_notre_carte: 'Our Menu',
    nav_plats_a_la_carte: 'À la carte dishes',
    nav_menus_formules: 'Menus & Set Meals',
    nav_no_product: 'No products in this category.',
    flyer_enter_site: 'Enter the site',
    tagline_restaurant: 'japanese restaurant · albi',

    hero_intro: 'Discover us in the heart of Albi city centre',
    hero_title_line1: 'our Sushi, our Sashimi,',
    hero_title_line2: 'our Yakitori, and other Japanese specialties',
    hero_reservation_link: 'Reservation',

    footer_desc: 'Authentic Japanese cuisine in the heart of Albi, prepared with fresh produce selected every day.',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'Takeaway',
    footer_hours_label: 'Opening Hours',
    footer_days_tue_thu: 'Tuesday – Thursday',
    footer_days_fri: 'Friday',
    footer_days_sat: 'Saturday',
    footer_days_sun_mon: 'Sunday – Monday',
    footer_closed: 'Closed',
    footer_alert_closed_lunch: 'Closed Friday and Saturday lunchtime',
    footer_note_hours: 'Hours may change during school holidays and public holidays.',
    footer_contact_label: 'Contact',
    footer_legal_label: 'Legal Information',
    footer_link_mentions: 'Legal Notice',
    footer_link_confidentialite: 'Privacy Policy',
    footer_link_cookies: 'Hyperlinks and Cookies',
    footer_link_espace_prive: 'Private Area',
    footer_copyright: '© {year} Bamboo Sushi – Japanese restaurant in Albi. All rights reserved.',
    footer_bar_confidentialite: 'Privacy',
    footer_bar_cookies: 'Cookies',

    b3_eyebrow_find_us: 'Find us',
    b3_title_info: 'Information',
    b3_title_info_em: 'Restaurant',
    b3_follow_us: 'Follow us',
    b3_takeaway: 'Takeaway',
    b3_address_label: 'Address',
    b3_hours_label: 'Opening Hours',
    b3_days_open: 'Tuesday to Saturday',
    b3_lunch: 'Lunch',
    b3_dinner: 'Dinner',
    b3_eyebrow_clients: 'What our guests say',
    b3_title_avis: 'Reviews',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Based on 441 Google reviews',
    b3_review1_text: 'Always a pleasure to come here! Never disappointed: freshness, cleanliness, the kindness of the staff… everything is perfect. The best sushi restaurant around, without a doubt.',
    b3_review1_date: '7 months ago',
    b3_review2_text: "Never disappointed by the quality of the fish. If you don't know what to order, I recommend the Bento. Several really good dishes to choose from.",
    b3_review2_date: '2 years ago',
    b3_review3_text: 'The ramen (takeaway) are excellent! The California Swordfish special is fantastic! Really great value for money, I highly recommend it.',
    b3_review3_date: 'A year ago',

    b5_quote: '"Every dish is an <em>intention</em> — a balance between <em>our fresh produce</em>, the <em>generosity</em> of our portions, and the finesse of <em>our flavours</em>."',
    b5_stat1_label: 'Fresh fish · daily delivery',
    b5_stat2_label: 'Years of experience',
    b5_stat3_label: 'Menu creations',
    b5_stat4_label: 'Google rating · 441 reviews',
    b5_prev: 'Previous',
    b5_next: 'Next',
    b5_slide1_label: 'Dragon Roll',
    b5_slide2_label: 'Spider Roll',
    b5_slide3_label: 'Rainbow Roll',
    b5_slide4_label: 'Volcano Roll',
    b5_slide5_label: 'Tropical Roll',
    b5_slide6_label: 'California Salmon Avocado',
    b5_slide7_label: 'Salmon, Avocado, Kiri',
    b5_slide8_label: 'Chirashi Assortment',

    res_eyebrow: 'Book',
    res_title: 'Book',
    res_title_em: 'a table',
    res_label_nom: 'Name',
    res_placeholder_nom: 'Your name',
    res_label_personnes: 'Number of guests',
    res_placeholder_personnes: 'e.g. 2',
    res_label_date: 'Preferred date',
    res_hint_days: 'Open Tue. — Sat. · Closed Sun. & Mon.',
    res_ferme_warn: 'The restaurant is closed on this day — please choose another day.',
    res_label_heure: 'Preferred time',
    res_choose_heure: 'Choose a time',
    res_note_required: 'Fields marked with an <strong>*</strong> must be filled in before sending the reservation',
    res_label_message: 'Message',
    res_placeholder_message: 'E.g.: allergy, special event, child seat...',
    res_btn_sms: 'Send reservation by SMS',
    res_alert_fields_required: 'Please fill in all required fields.',
    res_alert_closed_day: 'The restaurant is closed on Sundays and Mondays. Please choose another date.',

    menu_nav_plats: 'À la carte dishes',
    menu_nav_menus: 'Menus & Set Meals',
    menu_nav_reservation: 'Reservation',
    menu_banner_pre: 'Our',
    menu_banner_em: 'Menu',
    menu_loading: 'Loading menu…',
    menu_ref_singular: 'item',
    menu_ref_plural: 'items',
    menu_miso_note: 'All menus are served with cabbage salad and Miso soup',
    menu_empty_state: 'No dishes in this category at the moment.',
    menu_bottom_plats: 'Dishes',
    menu_bottom_menus: 'Menus',
    menu_bottom_menu: 'Menu',
    menu_bottom_reserver: 'Book',
    menu_bottom_call: 'Call',
    menu_home_title: 'Home',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · Tue–Sat',

    plats_banner_default: 'À la carte dishes',
    plats_banner_fallback: 'Our Menu',
    menus_banner_default: 'Menus',
    menus_banner_fallback: 'Our Menu',
    california_banner_default: 'California',

    fav_back: '← Back to menu',
    fav_title: 'Your Favourites',
    fav_empty: 'No favourite products yet. Feel free to build your favourites by clicking on your preferred dishes. You can deselect them by clicking again.',

    conn_title: 'Login',
    conn_email_ph: 'Email address',
    conn_password_ph: 'Password',
    conn_btn_login: 'Log in',
    conn_error: 'Invalid credentials.',
    conn_btn_home: 'Home',

    info_eyebrow: 'Information',

    legal_title: 'Legal Notice',
    legal_s1_title: '1 - Website Publisher',
    legal_s1_intro: 'In accordance with Article 6 of French Law No. 2004-575 of 21 June 2004 on confidence in the digital economy, users of the website <strong>https://www.bamboosushi.fr/</strong> are informed of the identity of the various parties involved in its creation and monitoring:',
    legal_s1_li_owner: '<strong>Owner:</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>Contact:</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>Address:</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI, France',
    legal_s1_li_id: '<strong>Registration:</strong> SARL with share capital of €3,500 – SIREN: 509 081 790 – RCS: Albi B 509 081 790',
    legal_s1_li_director: '<strong>Publication director:</strong> Mr Samphal Buth',
    legal_s1_li_host: '<strong>Host:</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA',
    legal_s2_title: '2 - Intellectual Property and Infringement',
    legal_s2_p: "SARL BAMBOO SUSHI owns the intellectual property rights and holds the usage rights for all elements accessible on the site (text, images, graphics, logos, videos, architecture, icons, sounds). Any reproduction, representation, modification, publication, or adaptation of all or part of the site's elements is prohibited without prior written authorisation. Any unauthorised use will be considered an infringement and prosecuted in accordance with Articles L.335-2 et seq. of the French Intellectual Property Code.",
    legal_s3_title: '3 - Limitation of Liability',
    legal_s3_p: "SARL BAMBOO SUSHI cannot be held liable for direct or indirect damage caused to the user's equipment when accessing the site. It declines all responsibility regarding the use of the information provided. Interactive spaces may be moderated. In the event of illegal content, the company reserves the right to remove it without notice and to prosecute the authors.",
    legal_s4_title: '4 - Data Protection Authority and Personal Data Management',
    legal_s4_p1: 'The site only collects personal information through forms that users are free to fill in. Data will only be used with your consent, to send you correspondence, quotes or information.',
    legal_s4_p2: 'In accordance with French Data Protection Act No. 78-17 of 6 January 1978 and the General Data Protection Regulation (GDPR), you have the right to access, rectify, delete and object to your data on simple request to: BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI, France.',
    legal_s4_p3: 'Statistical analyses may be carried out on anonymised data for the purpose of measuring site traffic.',
    legal_s5_title: '5 - Hyperlinks and Cookies',
    legal_s5_p: 'The site may contain links to other sites. BAMBOO SUSHI declines all responsibility regarding such external content. While browsing, cookies may be installed on your computer. These cookies are used only for statistical measurements and do not store personal information without your consent. You can refuse cookies via your browser settings. Cookies are kept for a maximum period of 13 months.',
    legal_s6_title: '6 - Applicable Law and Jurisdiction',
    legal_s6_p: 'Any dispute related to the use of the website <strong>https://www.bamboosushi.fr/</strong> is subject to French law. Except where the law does not permit it, exclusive jurisdiction is given to the competent courts of Albi.',
    legal_s7_title: '7 - Privacy Policy',
    legal_s7_intro: 'BAMBOO SUSHI attaches great importance to the protection of your personal data and respect for your privacy, in accordance with the General Data Protection Regulation (GDPR) in force since 25 May 2018.',
    legal_s7_collecte_label: 'Collection of personal data:',
    legal_s7_collecte_text: 'The personal data you may submit on our site (forms, customer area, contact requests) is used solely within the scope of the services offered by BAMBOO SUSHI. It is neither sold nor transmitted to third parties without your explicit consent.',
    legal_s7_finalites_label: 'Purposes of processing:',
    legal_s7_finalites_text: 'This data is collected in order to:',
    legal_s7_finalites_li1: 'contact you following a request or an order,',
    legal_s7_finalites_li2: 'manage your customer account,',
    legal_s7_finalites_li3: 'inform you about our news if you have given your consent,',
    legal_s7_finalites_li4: "ensure the proper functioning of the site's services.",
    legal_s7_conservation_label: 'Data retention:',
    legal_s7_conservation_text: 'Data is retained for the period necessary for the purposes for which it was collected, in compliance with applicable regulations.',
    legal_s7_droits_label: 'Your rights:',
    legal_s7_droits_text: 'In accordance with the GDPR, you have the right to access, rectify, delete and port your data, as well as the right to object to or restrict its processing. To exercise these rights, contact us at:',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI, France',
  },

  es: {
    nav_home: 'Inicio',
    nav_menu: 'La Carta',
    nav_infos: 'Info',
    nav_reservation: 'Reserva',
    nav_notre_carte: 'Nuestra Carta',
    nav_plats_a_la_carte: 'Platos a la carta',
    nav_menus_formules: 'Menús y Combinados',
    nav_no_product: 'Ningún producto en esta categoría.',
    flyer_enter_site: 'Entrar al sitio',
    tagline_restaurant: 'restaurante japonés · albi',

    hero_intro: 'Descúbrenos en pleno centro de Albi',
    hero_title_line1: 'nuestros Sushis, nuestros Sashimis,',
    hero_title_line2: 'nuestros Yakitoris y otras especialidades japonesas',
    hero_reservation_link: 'Reserva',

    footer_desc: 'Auténtica cocina japonesa en el corazón de Albi, preparada con productos frescos seleccionados cada día.',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'Para llevar',
    footer_hours_label: 'Horario',
    footer_days_tue_thu: 'Martes – Jueves',
    footer_days_fri: 'Viernes',
    footer_days_sat: 'Sábado',
    footer_days_sun_mon: 'Domingo – Lunes',
    footer_closed: 'Cerrado',
    footer_alert_closed_lunch: 'Cerrado viernes y sábado al mediodía',
    footer_note_hours: 'Los horarios pueden cambiar durante las vacaciones escolares y los días festivos.',
    footer_contact_label: 'Contacto',
    footer_legal_label: 'Información legal',
    footer_link_mentions: 'Aviso legal',
    footer_link_confidentialite: 'Política de privacidad',
    footer_link_cookies: 'Enlaces e hipervínculos y cookies',
    footer_link_espace_prive: 'Área privada',
    footer_copyright: '© {year} Bamboo Sushi – Restaurante japonés en Albi. Todos los derechos reservados.',
    footer_bar_confidentialite: 'Privacidad',
    footer_bar_cookies: 'Cookies',

    b3_eyebrow_find_us: 'Dónde encontrarnos',
    b3_title_info: 'Información',
    b3_title_info_em: 'Restaurante',
    b3_follow_us: 'Síguenos',
    b3_takeaway: 'Para llevar',
    b3_address_label: 'Dirección',
    b3_hours_label: 'Horario',
    b3_days_open: 'De martes a sábado',
    b3_lunch: 'Comida',
    b3_dinner: 'Cena',
    b3_eyebrow_clients: 'Nuestros clientes opinan',
    b3_title_avis: 'Reseñas',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Basado en 441 reseñas de Google',
    b3_review1_text: '¡Siempre es un placer venir aquí! Nunca decepciona: la frescura, la limpieza, la amabilidad del equipo… todo es perfecto. El mejor restaurante de sushi de la zona, sin duda.',
    b3_review1_date: 'Hace 7 meses',
    b3_review2_text: 'Nunca decepciona la calidad del pescado. Si no sabes qué pedir, te recomiendo el Bento. Tienen varios platos muy buenos.',
    b3_review2_date: 'Hace 2 años',
    b3_review3_text: '¡Los ramen (para llevar) son excelentes! ¡La especialidad California Pez Espada es lo mejor! La relación calidad-precio es realmente destacable, lo recomiendo al 100%.',
    b3_review3_date: 'Hace un año',

    b5_quote: '«Cada plato es una <em>intención</em> — un equilibrio entre <em>nuestros productos frescos</em>, la <em>generosidad</em> de nuestras raciones y la finura de <em>nuestros sabores</em>.»',
    b5_stat1_label: 'Pescado fresco · llegada diaria',
    b5_stat2_label: 'Años de experiencia',
    b5_stat3_label: 'Creaciones en la carta',
    b5_stat4_label: 'Valoración Google · 441 reseñas',
    b5_prev: 'Anterior',
    b5_next: 'Siguiente',
    b5_slide1_label: 'Dragon Roll',
    b5_slide2_label: 'Spider Roll',
    b5_slide3_label: 'Rainbow Roll',
    b5_slide4_label: 'Volcano Roll',
    b5_slide5_label: 'Tropical Roll',
    b5_slide6_label: 'California Salmón Aguacate',
    b5_slide7_label: 'Salmón, Aguacate, Kiri',
    b5_slide8_label: 'Surtido de Chirashis',

    res_eyebrow: 'Reservar',
    res_title: 'Reservar',
    res_title_em: 'una mesa',
    res_label_nom: 'Nombre',
    res_placeholder_nom: 'Tu nombre',
    res_label_personnes: 'Número de personas',
    res_placeholder_personnes: 'ej.: 2',
    res_label_date: 'Fecha deseada',
    res_hint_days: 'Abierto mar. — sáb. · Cerrado dom. y lun.',
    res_ferme_warn: 'El restaurante está cerrado este día — por favor elige otro día.',
    res_label_heure: 'Hora deseada',
    res_choose_heure: 'Elige una hora',
    res_note_required: 'Los campos marcados con un <strong>*</strong> deben completarse antes de enviar la reserva',
    res_label_message: 'Mensaje',
    res_placeholder_message: 'Ej.: alergia, evento especial, trona para niños...',
    res_btn_sms: 'Enviar la reserva por SMS',
    res_alert_fields_required: 'Por favor, completa todos los campos obligatorios.',
    res_alert_closed_day: 'El restaurante está cerrado los domingos y lunes. Por favor, elige otra fecha.',

    menu_nav_plats: 'Platos a la carta',
    menu_nav_menus: 'Menús y Combinados',
    menu_nav_reservation: 'Reserva',
    menu_banner_pre: 'Nuestro',
    menu_banner_em: 'Menú',
    menu_loading: 'Cargando la carta…',
    menu_ref_singular: 'referencia',
    menu_ref_plural: 'referencias',
    menu_miso_note: 'Todos los menús se sirven con ensalada de col y sopa Miso',
    menu_empty_state: 'No hay platos en esta categoría por el momento.',
    menu_bottom_plats: 'Platos',
    menu_bottom_menus: 'Menús',
    menu_bottom_menu: 'Menú',
    menu_bottom_reserver: 'Reservar',
    menu_bottom_call: 'Llamar',
    menu_home_title: 'Inicio',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · Mar-Sáb',

    plats_banner_default: 'Platos a la carta',
    plats_banner_fallback: 'Nuestra Carta',
    menus_banner_default: 'Menús',
    menus_banner_fallback: 'Nuestra Carta',
    california_banner_default: 'California',

    fav_back: '← Volver a la carta',
    fav_title: 'Tus Favoritos',
    fav_empty: 'Aún no tienes productos favoritos. No dudes en marcar tus favoritos haciendo clic en tus platos preferidos. Puedes deseleccionarlos haciendo clic de nuevo.',

    conn_title: 'Iniciar sesión',
    conn_email_ph: 'Correo electrónico',
    conn_password_ph: 'Contraseña',
    conn_btn_login: 'Iniciar sesión',
    conn_error: 'Credenciales no válidas.',
    conn_btn_home: 'Inicio',

    info_eyebrow: 'Información',

    legal_title: 'Aviso Legal',
    legal_s1_title: '1 - Editor del sitio',
    legal_s1_intro: 'De conformidad con el artículo 6 de la ley francesa n.º 2004-575 de 21 de junio de 2004 para la confianza en la economía digital, se informa a los usuarios del sitio web <strong>https://www.bamboosushi.fr/</strong> de la identidad de los distintos participantes en su realización y seguimiento:',
    legal_s1_li_owner: '<strong>Propietario:</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>Contacto:</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>Dirección:</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Francia',
    legal_s1_li_id: '<strong>Identificación:</strong> SARL con un capital social de 3500 € – SIREN: 509 081 790 – RCS: Albi B 509 081 790',
    legal_s1_li_director: '<strong>Director de publicación:</strong> Sr. Samphal Buth',
    legal_s1_li_host: '<strong>Alojamiento:</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, EE. UU.',
    legal_s2_title: '2 - Propiedad intelectual y falsificación',
    legal_s2_p: 'SARL BAMBOO SUSHI es propietaria de los derechos de propiedad intelectual y posee los derechos de uso sobre todos los elementos accesibles en el sitio (textos, imágenes, gráficos, logotipos, vídeos, arquitectura, iconos, sonidos). Queda prohibida cualquier reproducción, representación, modificación, publicación o adaptación total o parcial de los elementos del sitio sin autorización previa por escrito. Cualquier uso no autorizado se considerará una falsificación y será perseguido de conformidad con los artículos L.335-2 y siguientes del Código de la Propiedad Intelectual francés.',
    legal_s3_title: '3 - Limitación de responsabilidad',
    legal_s3_p: 'SARL BAMBOO SUSHI no podrá ser considerada responsable de los daños directos o indirectos causados al equipo del usuario durante el acceso al sitio. Declina toda responsabilidad en cuanto al uso de la información presente. Los espacios interactivos pueden ser moderados. En caso de contenido ilícito, la empresa se reserva el derecho de eliminarlo sin previo aviso y de perseguir a sus autores.',
    legal_s4_title: '4 - CNIL y gestión de datos personales',
    legal_s4_p1: 'El sitio solo recopila información personal a través de los formularios que el usuario decide libremente rellenar. Los datos solo se utilizarán con su consentimiento, para enviarle correspondencia, presupuestos o información.',
    legal_s4_p2: 'De conformidad con la ley francesa de Informática y Libertades n.º 78-17 de 6 de enero de 1978 y con el Reglamento General de Protección de Datos (RGPD), usted dispone de un derecho de acceso, rectificación, supresión y oposición, previa solicitud a: BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI, Francia.',
    legal_s4_p3: 'Se pueden realizar análisis estadísticos sobre datos anonimizados con el fin de medir la audiencia del sitio.',
    legal_s5_title: '5 - Enlaces e hipervínculos y cookies',
    legal_s5_p: 'El sitio puede contener enlaces a otros sitios. BAMBOO SUSHI declina toda responsabilidad respecto a dichos contenidos externos. Durante la navegación, pueden instalarse cookies en su ordenador. Estas cookies solo permiten mediciones estadísticas y no almacenan información personal sin su consentimiento. Puede rechazar las cookies desde la configuración de su navegador. Las cookies se conservan durante un período máximo de 13 meses.',
    legal_s6_title: '6 - Derecho aplicable y jurisdicción',
    legal_s6_p: 'Cualquier litigio relacionado con el uso del sitio <strong>https://www.bamboosushi.fr/</strong> está sujeto al derecho francés. Salvo en los casos en que la ley no lo permita, se atribuye competencia exclusiva a los tribunales de Albi.',
    legal_s7_title: '7 - Política de privacidad',
    legal_s7_intro: 'BAMBOO SUSHI concede gran importancia a la protección de sus datos personales y al respeto de su privacidad, de conformidad con el Reglamento General de Protección de Datos (RGPD) en vigor desde el 25 de mayo de 2018.',
    legal_s7_collecte_label: 'Recopilación de datos personales:',
    legal_s7_collecte_text: 'Los datos personales que pueda transmitir en nuestro sitio (formularios, área de cliente, solicitudes de contacto) se utilizan únicamente en el marco de los servicios ofrecidos por BAMBOO SUSHI. No se revenden ni se transmiten a terceros sin su consentimiento explícito.',
    legal_s7_finalites_label: 'Finalidades del tratamiento:',
    legal_s7_finalites_text: 'Estos datos se recopilan para:',
    legal_s7_finalites_li1: 'contactarle tras una solicitud o un pedido,',
    legal_s7_finalites_li2: 'gestionar su cuenta de cliente,',
    legal_s7_finalites_li3: 'informarle de nuestras novedades si ha dado su consentimiento,',
    legal_s7_finalites_li4: 'garantizar el correcto funcionamiento de los servicios del sitio.',
    legal_s7_conservation_label: 'Conservación de los datos:',
    legal_s7_conservation_text: 'Los datos se conservan durante el tiempo necesario para las finalidades para las que fueron recopilados, de conformidad con la normativa vigente.',
    legal_s7_droits_label: 'Sus derechos:',
    legal_s7_droits_text: 'De conformidad con el RGPD, usted dispone de un derecho de acceso, rectificación, supresión y portabilidad de sus datos, así como de un derecho de oposición o limitación del tratamiento. Para ejercer estos derechos, contáctenos en:',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Francia',
  },

  it: {
    nav_home: 'Home',
    nav_menu: 'Il Menù',
    nav_infos: 'Info',
    nav_reservation: 'Prenotazione',
    nav_notre_carte: 'Il Nostro Menù',
    nav_plats_a_la_carte: 'Piatti alla carta',
    nav_menus_formules: 'Menu & Formule',
    nav_no_product: 'Nessun prodotto in questa categoria.',
    flyer_enter_site: 'Entra nel sito',
    tagline_restaurant: 'ristorante giapponese · albi',

    hero_intro: 'Scoprici nel cuore del centro di Albi',
    hero_title_line1: 'i nostri Sushi, i nostri Sashimi,',
    hero_title_line2: 'i nostri Yakitori e altre specialità giapponesi',
    hero_reservation_link: 'Prenotazione',

    footer_desc: 'Autentica cucina giapponese nel cuore di Albi, preparata con prodotti freschi selezionati ogni giorno.',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'Da asporto',
    footer_hours_label: 'Orari',
    footer_days_tue_thu: 'Martedì – Giovedì',
    footer_days_fri: 'Venerdì',
    footer_days_sat: 'Sabato',
    footer_days_sun_mon: 'Domenica – Lunedì',
    footer_closed: 'Chiuso',
    footer_alert_closed_lunch: 'Chiuso venerdì e sabato a pranzo',
    footer_note_hours: 'Gli orari possono cambiare durante le vacanze scolastiche e i giorni festivi.',
    footer_contact_label: 'Contatti',
    footer_legal_label: 'Informazioni legali',
    footer_link_mentions: 'Note legali',
    footer_link_confidentialite: 'Informativa sulla privacy',
    footer_link_cookies: 'Link ipertestuali e cookie',
    footer_link_espace_prive: 'Area privata',
    footer_copyright: '© {year} Bamboo Sushi – Ristorante giapponese ad Albi. Tutti i diritti riservati.',
    footer_bar_confidentialite: 'Privacy',
    footer_bar_cookies: 'Cookie',

    b3_eyebrow_find_us: 'Dove trovarci',
    b3_title_info: 'Informazioni',
    b3_title_info_em: 'Ristorante',
    b3_follow_us: 'Seguici',
    b3_takeaway: 'Da asporto',
    b3_address_label: 'Indirizzo',
    b3_hours_label: 'Orari',
    b3_days_open: 'Dal martedì al sabato',
    b3_lunch: 'Pranzo',
    b3_dinner: 'Cena',
    b3_eyebrow_clients: 'I nostri clienti parlano',
    b3_title_avis: 'Recensioni',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Basato su 441 recensioni Google',
    b3_review1_text: 'Sempre un piacere venire qui! Mai delusa: la freschezza, la pulizia, la gentilezza dello staff… tutto è perfetto. Il miglior ristorante di sushi della zona, senza dubbio.',
    b3_review1_date: '7 mesi fa',
    b3_review2_text: 'Mai deluso dalla qualità del pesce. Se non sapete cosa ordinare, vi consiglio il Bento. Ci sono diversi piatti davvero buoni.',
    b3_review2_date: '2 anni fa',
    b3_review3_text: 'I ramen (da asporto) sono eccellenti! La specialità California Pesce Spada è il top! Il rapporto qualità-prezzo è davvero notevole, lo consiglio al 100%.',
    b3_review3_date: 'Un anno fa',

    b5_quote: '«Ogni piatto è un\'<em>intenzione</em> — un equilibrio tra <em>i nostri prodotti freschi</em>, la <em>generosità</em> delle nostre porzioni e la finezza dei <em>nostri sapori</em>.»',
    b5_stat1_label: 'Pesce fresco · arrivo quotidiano',
    b5_stat2_label: 'Anni di esperienza',
    b5_stat3_label: 'Creazioni nel menù',
    b5_stat4_label: 'Valutazione Google · 441 recensioni',
    b5_prev: 'Precedente',
    b5_next: 'Successivo',
    b5_slide1_label: 'Dragon Roll',
    b5_slide2_label: 'Spider Roll',
    b5_slide3_label: 'Rainbow Roll',
    b5_slide4_label: 'Volcano Roll',
    b5_slide5_label: 'Tropical Roll',
    b5_slide6_label: 'California Salmone Avocado',
    b5_slide7_label: 'Salmone, Avocado, Kiri',
    b5_slide8_label: 'Assortimento di Chirashi',

    res_eyebrow: 'Prenota',
    res_title: 'Prenota',
    res_title_em: 'un tavolo',
    res_label_nom: 'Nome',
    res_placeholder_nom: 'Il tuo nome',
    res_label_personnes: 'Numero di persone',
    res_placeholder_personnes: 'es.: 2',
    res_label_date: 'Data desiderata',
    res_hint_days: 'Aperto mar. — sab. · Chiuso dom. e lun.',
    res_ferme_warn: 'Il ristorante è chiuso in questo giorno — scegli un altro giorno.',
    res_label_heure: 'Ora desiderata',
    res_choose_heure: 'Scegli un orario',
    res_note_required: 'I campi contrassegnati con un <strong>*</strong> devono essere compilati prima di inviare la prenotazione',
    res_label_message: 'Messaggio',
    res_placeholder_message: 'Es.: allergia, evento speciale, seggiolone...',
    res_btn_sms: 'Invia la prenotazione via SMS',
    res_alert_fields_required: 'Si prega di compilare tutti i campi obbligatori.',
    res_alert_closed_day: "Il ristorante è chiuso la domenica e il lunedì. Scegli un'altra data.",

    menu_nav_plats: 'Piatti alla carta',
    menu_nav_menus: 'Menu & Formule',
    menu_nav_reservation: 'Prenotazione',
    menu_banner_pre: 'Il Nostro',
    menu_banner_em: 'Menù',
    menu_loading: 'Caricamento del menù…',
    menu_ref_singular: 'referenza',
    menu_ref_plural: 'referenze',
    menu_miso_note: 'Tutti i menu sono accompagnati da insalata di cavolo e zuppa Miso',
    menu_empty_state: 'Nessun piatto in questa categoria al momento.',
    menu_bottom_plats: 'Piatti',
    menu_bottom_menus: 'Menu',
    menu_bottom_menu: 'Menu',
    menu_bottom_reserver: 'Prenota',
    menu_bottom_call: 'Chiama',
    menu_home_title: 'Home',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · Mar–Sab',

    plats_banner_default: 'Piatti alla carta',
    plats_banner_fallback: 'Il Nostro Menù',
    menus_banner_default: 'Menu',
    menus_banner_fallback: 'Il Nostro Menù',
    california_banner_default: 'California',

    fav_back: '← Torna al menù',
    fav_title: 'I Tuoi Preferiti',
    fav_empty: 'Nessun prodotto preferito per il momento. Aggiungi i tuoi piatti preferiti cliccando su di essi. Puoi deselezionarli cliccando di nuovo.',

    conn_title: 'Accesso',
    conn_email_ph: 'Indirizzo email',
    conn_password_ph: 'Password',
    conn_btn_login: 'Accedi',
    conn_error: 'Credenziali non valide.',
    conn_btn_home: 'Home',

    info_eyebrow: 'Informazione',

    legal_title: 'Note Legali',
    legal_s1_title: '1 - Editore del sito',
    legal_s1_intro: "Ai sensi dell'articolo 6 della legge francese n. 2004-575 del 21 giugno 2004 sulla fiducia nell'economia digitale, si informano gli utenti del sito internet <strong>https://www.bamboosushi.fr/</strong> dell'identità dei diversi soggetti coinvolti nella sua realizzazione e gestione:",
    legal_s1_li_owner: '<strong>Proprietario:</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>Contatto:</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>Indirizzo:</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Francia',
    legal_s1_li_id: '<strong>Identificazione:</strong> SARL con capitale sociale di 3.500 € – SIREN: 509 081 790 – RCS: Albi B 509 081 790',
    legal_s1_li_director: '<strong>Direttore della pubblicazione:</strong> Sig. Samphal Buth',
    legal_s1_li_host: '<strong>Hosting:</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA',
    legal_s2_title: '2 - Proprietà intellettuale e contraffazione',
    legal_s2_p: "SARL BAMBOO SUSHI è proprietaria dei diritti di proprietà intellettuale e detiene i diritti d'uso su tutti gli elementi accessibili sul sito (testi, immagini, grafica, loghi, video, architettura, icone, suoni). È vietata qualsiasi riproduzione, rappresentazione, modifica, pubblicazione o adattamento totale o parziale degli elementi del sito senza previa autorizzazione scritta. Qualsiasi utilizzo non autorizzato sarà considerato una contraffazione e perseguito ai sensi degli articoli L.335-2 e seguenti del Codice della Proprietà Intellettuale francese.",
    legal_s3_title: '3 - Limitazioni di responsabilità',
    legal_s3_p: "SARL BAMBOO SUSHI non potrà essere ritenuta responsabile dei danni diretti o indiretti causati all'apparecchiatura dell'utente durante l'accesso al sito. Declina ogni responsabilità riguardo all'uso delle informazioni presenti. Gli spazi interattivi possono essere moderati. In caso di contenuto illecito, l'azienda si riserva il diritto di rimuoverlo senza preavviso e di perseguire gli autori.",
    legal_s4_title: '4 - Autorità Garante e gestione dei dati personali',
    legal_s4_p1: "Il sito raccoglie informazioni personali solo tramite i moduli che l'utente è libero di compilare. I dati saranno utilizzati solo con il vostro consenso, per inviarvi corrispondenza, preventivi o informazioni.",
    legal_s4_p2: "In conformità con la legge francese Informatica e Libertà n. 78-17 del 6 gennaio 1978 e con il Regolamento Generale sulla Protezione dei Dati (GDPR), avete il diritto di accesso, rettifica, cancellazione e opposizione, previa semplice richiesta a: BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI, Francia.",
    legal_s4_p3: "Possono essere effettuate analisi statistiche su dati anonimizzati al fine di misurare l'affluenza al sito.",
    legal_s5_title: '5 - Link ipertestuali e cookie',
    legal_s5_p: 'Il sito può contenere link verso altri siti. BAMBOO SUSHI declina ogni responsabilità riguardo a tali contenuti esterni. Durante la navigazione, sul vostro computer possono essere installati dei cookie. Questi cookie consentono unicamente misurazioni statistiche e non memorizzano informazioni personali senza il vostro consenso. Potete rifiutare i cookie tramite le impostazioni del vostro browser. I cookie vengono conservati per un periodo massimo di 13 mesi.',
    legal_s6_title: '6 - Legge applicabile e attribuzione di giurisdizione',
    legal_s6_p: "Qualsiasi controversia relativa all'utilizzo del sito <strong>https://www.bamboosushi.fr/</strong> è soggetta alla legge francese. Salvo nei casi in cui la legge non lo consenta, viene attribuita competenza esclusiva ai tribunali competenti di Albi.",
    legal_s7_title: '7 - Informativa sulla privacy',
    legal_s7_intro: "BAMBOO SUSHI attribuisce grande importanza alla protezione dei vostri dati personali e al rispetto della vostra privacy, in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR) in vigore dal 25 maggio 2018.",
    legal_s7_collecte_label: 'Raccolta dei dati personali:',
    legal_s7_collecte_text: "I dati personali che potete trasmettere sul nostro sito (moduli, area clienti, richieste di contatto) sono utilizzati esclusivamente nell'ambito dei servizi offerti da BAMBOO SUSHI. Non vengono né rivenduti né trasmessi a terzi senza il vostro consenso esplicito.",
    legal_s7_finalites_label: 'Finalità del trattamento:',
    legal_s7_finalites_text: 'Questi dati vengono raccolti per:',
    legal_s7_finalites_li1: 'contattarvi in seguito a una richiesta o un ordine,',
    legal_s7_finalites_li2: 'gestire il vostro account cliente,',
    legal_s7_finalites_li3: 'informarvi sulle nostre novità se avete dato il vostro consenso,',
    legal_s7_finalites_li4: 'garantire il corretto funzionamento dei servizi del sito.',
    legal_s7_conservation_label: 'Conservazione dei dati:',
    legal_s7_conservation_text: 'I dati vengono conservati per il tempo necessario alle finalità per cui sono stati raccolti, nel rispetto della normativa vigente.',
    legal_s7_droits_label: 'I vostri diritti:',
    legal_s7_droits_text: 'In conformità con il GDPR, avete diritto di accesso, rettifica, cancellazione e portabilità dei vostri dati, nonché diritto di opposizione o limitazione del trattamento. Per esercitare questi diritti, contattateci a:',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Francia',
  },

  de: {
    nav_home: 'Startseite',
    nav_menu: 'Die Speisekarte',
    nav_infos: 'Infos',
    nav_reservation: 'Reservierung',
    nav_notre_carte: 'Unsere Karte',
    nav_plats_a_la_carte: 'Gerichte à la carte',
    nav_menus_formules: 'Menüs & Kombinationen',
    nav_no_product: 'Kein Produkt in dieser Kategorie.',
    flyer_enter_site: 'Zur Website',
    tagline_restaurant: 'japanisches restaurant · albi',

    hero_intro: 'Entdecken Sie uns mitten im Zentrum von Albi',
    hero_title_line1: 'unser Sushi, unser Sashimi,',
    hero_title_line2: 'unser Yakitori und weitere japanische Spezialitäten',
    hero_reservation_link: 'Reservierung',

    footer_desc: 'Authentische japanische Küche im Herzen von Albi, zubereitet mit täglich frisch ausgewählten Zutaten.',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'Zum Mitnehmen',
    footer_hours_label: 'Öffnungszeiten',
    footer_days_tue_thu: 'Dienstag – Donnerstag',
    footer_days_fri: 'Freitag',
    footer_days_sat: 'Samstag',
    footer_days_sun_mon: 'Sonntag – Montag',
    footer_closed: 'Geschlossen',
    footer_alert_closed_lunch: 'Freitag- und Samstagmittag geschlossen',
    footer_note_hours: 'Die Öffnungszeiten können während der Schulferien und an Feiertagen abweichen.',
    footer_contact_label: 'Kontakt',
    footer_legal_label: 'Rechtliche Hinweise',
    footer_link_mentions: 'Impressum',
    footer_link_confidentialite: 'Datenschutzerklärung',
    footer_link_cookies: 'Hyperlinks und Cookies',
    footer_link_espace_prive: 'Privatbereich',
    footer_copyright: '© {year} Bamboo Sushi – Japanisches Restaurant in Albi. Alle Rechte vorbehalten.',
    footer_bar_confidentialite: 'Datenschutz',
    footer_bar_cookies: 'Cookies',

    b3_eyebrow_find_us: 'So finden Sie uns',
    b3_title_info: 'Informationen',
    b3_title_info_em: 'Restaurant',
    b3_follow_us: 'Folgen Sie uns',
    b3_takeaway: 'Zum Mitnehmen',
    b3_address_label: 'Adresse',
    b3_hours_label: 'Öffnungszeiten',
    b3_days_open: 'Von Dienstag bis Samstag',
    b3_lunch: 'Mittagessen',
    b3_dinner: 'Abendessen',
    b3_eyebrow_clients: 'Unsere Gäste berichten',
    b3_title_avis: 'Bewertungen',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Basierend auf 441 Google-Bewertungen',
    b3_review1_text: 'Immer wieder ein Vergnügen, hierher zu kommen! Nie enttäuscht: die Frische, die Sauberkeit, die Freundlichkeit des Teams… alles ist perfekt. Das beste Sushi-Restaurant der Gegend, ohne Zweifel.',
    b3_review1_date: 'Vor 7 Monaten',
    b3_review2_text: 'Nie enttäuscht von der Qualität des Fisches. Wenn Sie nicht wissen, was Sie bestellen sollen, empfehle ich die Bento-Box. Es gibt mehrere wirklich gute Gerichte.',
    b3_review2_date: 'Vor 2 Jahren',
    b3_review3_text: 'Die Ramen (zum Mitnehmen) sind hervorragend! Die Spezialität California Schwertfisch ist top! Das Preis-Leistungs-Verhältnis ist wirklich bemerkenswert, ich empfehle es zu 100 %.',
    b3_review3_date: 'Vor einem Jahr',

    b5_quote: '„Jedes Gericht ist eine <em>Absicht</em> — eine Balance zwischen <em>unseren frischen Zutaten</em>, der <em>Großzügigkeit</em> unserer Portionen und der Finesse <em>unserer Aromen</em>."',
    b5_stat1_label: 'Frischer Fisch · tägliche Lieferung',
    b5_stat2_label: 'Jahre Erfahrung',
    b5_stat3_label: 'Kreationen auf der Karte',
    b5_stat4_label: 'Google-Bewertung · 441 Rezensionen',
    b5_prev: 'Zurück',
    b5_next: 'Weiter',
    b5_slide1_label: 'Dragon Roll',
    b5_slide2_label: 'Spider Roll',
    b5_slide3_label: 'Rainbow Roll',
    b5_slide4_label: 'Volcano Roll',
    b5_slide5_label: 'Tropical Roll',
    b5_slide6_label: 'California Lachs-Avocado',
    b5_slide7_label: 'Lachs, Avocado, Kiri',
    b5_slide8_label: 'Chirashi-Auswahl',

    res_eyebrow: 'Reservieren',
    res_title: 'Tisch',
    res_title_em: 'reservieren',
    res_label_nom: 'Name',
    res_placeholder_nom: 'Ihr Name',
    res_label_personnes: 'Anzahl der Personen',
    res_placeholder_personnes: 'z. B. 2',
    res_label_date: 'Gewünschtes Datum',
    res_hint_days: 'Geöffnet Di. — Sa. · Geschlossen So. & Mo.',
    res_ferme_warn: 'Das Restaurant ist an diesem Tag geschlossen — bitte wählen Sie einen anderen Tag.',
    res_label_heure: 'Gewünschte Uhrzeit',
    res_choose_heure: 'Uhrzeit wählen',
    res_note_required: 'Mit <strong>*</strong> markierte Felder müssen vor dem Absenden der Reservierung ausgefüllt werden',
    res_label_message: 'Nachricht',
    res_placeholder_message: 'Z. B.: Allergie, besonderer Anlass, Kinderstuhl...',
    res_btn_sms: 'Reservierung per SMS senden',
    res_alert_fields_required: 'Bitte füllen Sie alle Pflichtfelder aus.',
    res_alert_closed_day: 'Das Restaurant ist sonntags und montags geschlossen. Bitte wählen Sie ein anderes Datum.',

    menu_nav_plats: 'Gerichte à la carte',
    menu_nav_menus: 'Menüs & Kombinationen',
    menu_nav_reservation: 'Reservierung',
    menu_banner_pre: 'Unsere',
    menu_banner_em: 'Speisekarte',
    menu_loading: 'Speisekarte wird geladen…',
    menu_ref_singular: 'Gericht',
    menu_ref_plural: 'Gerichte',
    menu_miso_note: 'Alle Menüs werden mit Kohlsalat und Miso-Suppe serviert',
    menu_empty_state: 'Derzeit keine Gerichte in dieser Kategorie.',
    menu_bottom_plats: 'Gerichte',
    menu_bottom_menus: 'Menüs',
    menu_bottom_menu: 'Menü',
    menu_bottom_reserver: 'Reservieren',
    menu_bottom_call: 'Anrufen',
    menu_home_title: 'Startseite',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · Di–Sa',

    plats_banner_default: 'Gerichte à la carte',
    plats_banner_fallback: 'Unsere Karte',
    menus_banner_default: 'Menüs',
    menus_banner_fallback: 'Unsere Karte',
    california_banner_default: 'California',

    fav_back: '← Zurück zur Karte',
    fav_title: 'Ihre Favoriten',
    fav_empty: 'Noch keine Lieblingsprodukte. Klicken Sie einfach auf Ihre bevorzugten Gerichte, um sie zu Ihren Favoriten hinzuzufügen. Sie können die Auswahl durch erneutes Klicken aufheben.',

    conn_title: 'Anmeldung',
    conn_email_ph: 'E-Mail-Adresse',
    conn_password_ph: 'Passwort',
    conn_btn_login: 'Anmelden',
    conn_error: 'Ungültige Anmeldedaten.',
    conn_btn_home: 'Startseite',

    info_eyebrow: 'Information',

    legal_title: 'Impressum',
    legal_s1_title: '1 - Herausgeber der Website',
    legal_s1_intro: 'Gemäß Artikel 6 des französischen Gesetzes Nr. 2004-575 vom 21. Juni 2004 über das Vertrauen in die digitale Wirtschaft werden die Nutzer der Website <strong>https://www.bamboosushi.fr/</strong> über die Identität der verschiedenen an ihrer Erstellung und Betreuung beteiligten Parteien informiert:',
    legal_s1_li_owner: '<strong>Inhaber:</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>Kontakt:</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>Adresse:</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Frankreich',
    legal_s1_li_id: '<strong>Registrierung:</strong> SARL mit einem Gesellschaftskapital von 3.500 € – SIREN: 509 081 790 – RCS: Albi B 509 081 790',
    legal_s1_li_director: '<strong>Verantwortlicher für die Veröffentlichung:</strong> Herr Samphal Buth',
    legal_s1_li_host: '<strong>Hosting:</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA',
    legal_s2_title: '2 - Geistiges Eigentum und Fälschung',
    legal_s2_p: 'Die SARL BAMBOO SUSHI ist Inhaberin der Rechte am geistigen Eigentum und der Nutzungsrechte an allen auf der Website zugänglichen Elementen (Texte, Bilder, Grafiken, Logos, Videos, Architektur, Symbole, Töne). Jegliche Vervielfältigung, Darstellung, Änderung, Veröffentlichung oder Anpassung der Elemente der Website, ganz oder teilweise, ist ohne vorherige schriftliche Genehmigung untersagt. Jede nicht autorisierte Nutzung gilt als Fälschung und wird gemäß den Artikeln L.335-2 ff. des französischen Gesetzes über geistiges Eigentum strafrechtlich verfolgt.',
    legal_s3_title: '3 - Haftungsbeschränkung',
    legal_s3_p: 'Die SARL BAMBOO SUSHI haftet nicht für direkte oder indirekte Schäden, die beim Zugriff auf die Website an der Ausrüstung des Nutzers entstehen. Sie übernimmt keine Verantwortung für die Nutzung der bereitgestellten Informationen. Interaktive Bereiche können moderiert werden. Bei illegalen Inhalten behält sich das Unternehmen das Recht vor, diese ohne Vorankündigung zu entfernen und die Urheber strafrechtlich zu verfolgen.',
    legal_s4_title: '4 - Datenschutzbehörde und Verwaltung personenbezogener Daten',
    legal_s4_p1: 'Die Website erhebt personenbezogene Daten ausschließlich über Formulare, die der Nutzer freiwillig ausfüllt. Die Daten werden nur mit Ihrer Zustimmung verwendet, um Ihnen Schreiben, Angebote oder Informationen zuzusenden.',
    legal_s4_p2: 'Gemäß dem französischen Datenschutzgesetz Nr. 78-17 vom 6. Januar 1978 und der Datenschutz-Grundverordnung (DSGVO) haben Sie das Recht auf Auskunft, Berichtigung, Löschung und Widerspruch. Wenden Sie sich hierfür einfach an: BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI, Frankreich.',
    legal_s4_p3: 'Statistische Auswertungen können anhand anonymisierter Daten zur Messung der Besucherzahlen durchgeführt werden.',
    legal_s5_title: '5 - Hyperlinks und Cookies',
    legal_s5_p: 'Die Website kann Links zu anderen Websites enthalten. BAMBOO SUSHI übernimmt keine Verantwortung für solche externen Inhalte. Beim Surfen können Cookies auf Ihrem Computer installiert werden. Diese Cookies dienen ausschließlich statistischen Zwecken und speichern keine personenbezogenen Daten ohne Ihre Zustimmung. Sie können Cookies über die Einstellungen Ihres Browsers ablehnen. Cookies werden für einen Zeitraum von maximal 13 Monaten gespeichert.',
    legal_s6_title: '6 - Anwendbares Recht und Gerichtsstand',
    legal_s6_p: 'Jede Streitigkeit im Zusammenhang mit der Nutzung der Website <strong>https://www.bamboosushi.fr/</strong> unterliegt französischem Recht. Außer in Fällen, in denen das Gesetz dies nicht zulässt, wird den zuständigen Gerichten von Albi die ausschließliche Zuständigkeit übertragen.',
    legal_s7_title: '7 - Datenschutzerklärung',
    legal_s7_intro: 'BAMBOO SUSHI legt großen Wert auf den Schutz Ihrer personenbezogenen Daten und die Achtung Ihrer Privatsphäre, gemäß der seit dem 25. Mai 2018 geltenden Datenschutz-Grundverordnung (DSGVO).',
    legal_s7_collecte_label: 'Erhebung personenbezogener Daten:',
    legal_s7_collecte_text: 'Die personenbezogenen Daten, die Sie uns über unsere Website übermitteln (Formulare, Kundenbereich, Kontaktaufnahme), werden ausschließlich im Rahmen der von BAMBOO SUSHI angebotenen Dienstleistungen verwendet. Sie werden weder verkauft noch ohne Ihre ausdrückliche Zustimmung an Dritte weitergegeben.',
    legal_s7_finalites_label: 'Zwecke der Verarbeitung:',
    legal_s7_finalites_text: 'Diese Daten werden erhoben, um:',
    legal_s7_finalites_li1: 'Sie nach einer Anfrage oder Bestellung zu kontaktieren,',
    legal_s7_finalites_li2: 'Ihr Kundenkonto zu verwalten,',
    legal_s7_finalites_li3: 'Sie über unsere Neuigkeiten zu informieren, sofern Sie zugestimmt haben,',
    legal_s7_finalites_li4: 'das ordnungsgemäße Funktionieren der Website-Dienste zu gewährleisten.',
    legal_s7_conservation_label: 'Aufbewahrung der Daten:',
    legal_s7_conservation_text: 'Die Daten werden für die Dauer aufbewahrt, die für die Zwecke erforderlich ist, für die sie erhoben wurden, unter Einhaltung der geltenden Vorschriften.',
    legal_s7_droits_label: 'Ihre Rechte:',
    legal_s7_droits_text: 'Gemäß der DSGVO haben Sie das Recht auf Auskunft, Berichtigung, Löschung und Übertragbarkeit Ihrer Daten sowie das Recht auf Widerspruch oder Einschränkung der Verarbeitung. Um diese Rechte auszuüben, kontaktieren Sie uns unter:',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI, Frankreich',
  },

  ja: {
    nav_home: 'トップページ',
    nav_menu: 'メニュー',
    nav_infos: '店舗情報',
    nav_reservation: 'ご予約',
    nav_notre_carte: '当店のメニュー',
    nav_plats_a_la_carte: 'アラカルト料理',
    nav_menus_formules: 'セットメニュー',
    nav_no_product: 'このカテゴリーに商品がありません。',
    flyer_enter_site: 'サイトに入る',
    tagline_restaurant: '日本料理レストラン・アルビ',

    hero_intro: 'アルビの中心地であなたをお待ちしております',
    hero_title_line1: '寿司、刺身、',
    hero_title_line2: '焼き鳥、その他日本料理の数々',
    hero_reservation_link: 'ご予約',

    footer_desc: 'アルビの中心で、毎日厳選された新鮮な食材を使った本格的な日本料理をご提供しています。',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: 'テイクアウト',
    footer_hours_label: '営業時間',
    footer_days_tue_thu: '火曜日〜木曜日',
    footer_days_fri: '金曜日',
    footer_days_sat: '土曜日',
    footer_days_sun_mon: '日曜日・月曜日',
    footer_closed: '定休日',
    footer_alert_closed_lunch: '金曜日・土曜日のランチタイムは休業',
    footer_note_hours: '学校休暇期間や祝日には営業時間が変更になる場合があります。',
    footer_contact_label: 'お問い合わせ',
    footer_legal_label: '法的情報',
    footer_link_mentions: '法的表示',
    footer_link_confidentialite: 'プライバシーポリシー',
    footer_link_cookies: 'リンク・クッキーについて',
    footer_link_espace_prive: '会員専用ページ',
    footer_copyright: '© {year} Bamboo Sushi – アルビの日本料理レストラン。無断複製・転載を禁じます。',
    footer_bar_confidentialite: 'プライバシー',
    footer_bar_cookies: 'クッキー',

    b3_eyebrow_find_us: 'アクセス',
    b3_title_info: '店舗',
    b3_title_info_em: '情報',
    b3_follow_us: 'フォローする',
    b3_takeaway: 'テイクアウト',
    b3_address_label: '住所',
    b3_hours_label: '営業時間',
    b3_days_open: '火曜日から土曜日まで',
    b3_lunch: 'ランチ',
    b3_dinner: 'ディナー',
    b3_eyebrow_clients: 'お客様の声',
    b3_title_avis: 'レビュー',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: 'Google レビュー441件に基づく',
    b3_review1_text: 'いつ来ても楽しい時間を過ごせます！新鮮さ、清潔さ、スタッフの優しさ…すべてが完璧です。間違いなくこの辺りで一番の寿司レストランです。',
    b3_review1_date: '7ヶ月前',
    b3_review2_text: '魚の質にはいつも満足しています。何を注文するか迷ったら、弁当がおすすめです。美味しい料理がたくさんあります。',
    b3_review2_date: '2年前',
    b3_review3_text: 'ラーメン（テイクアウト）は絶品です！カリフォルニア・エスパドンのスペシャリテは最高！コストパフォーマンスも本当に素晴らしく、100%おすすめします。',
    b3_review3_date: '1年前',

    b5_quote: '「どの一皿にも<em>想い</em>が込められています —— <em>新鮮な食材</em>、<em>たっぷり</em>のボリューム、そして<em>繊細な味わい</em>の絶妙なバランス。」',
    b5_stat1_label: '新鮮な魚・毎日仕入れ',
    b5_stat2_label: '経験年数',
    b5_stat3_label: 'メニューの創作数',
    b5_stat4_label: 'Google評価・441件のレビュー',
    b5_prev: '前へ',
    b5_next: '次へ',
    b5_slide1_label: 'ドラゴンロール',
    b5_slide2_label: 'スパイダーロール',
    b5_slide3_label: 'レインボーロール',
    b5_slide4_label: 'ボルケーノロール',
    b5_slide5_label: 'トロピカルロール',
    b5_slide6_label: 'カリフォルニア サーモンアボカド',
    b5_slide7_label: 'サーモン、アボカド、クリームチーズ',
    b5_slide8_label: 'ちらし寿司の盛り合わせ',

    res_eyebrow: 'ご予約',
    res_title: 'テーブルの',
    res_title_em: 'ご予約',
    res_label_nom: 'お名前',
    res_placeholder_nom: 'お名前を入力',
    res_label_personnes: '人数',
    res_placeholder_personnes: '例：2名',
    res_label_date: 'ご希望の日付',
    res_hint_days: '火〜土曜営業・日月定休',
    res_ferme_warn: '本日は定休日です。別の日をお選びください。',
    res_label_heure: 'ご希望の時間',
    res_choose_heure: '時間を選択してください',
    res_note_required: '<strong>*</strong>の付いた項目は、予約送信前に必ずご入力ください',
    res_label_message: 'メッセージ',
    res_placeholder_message: '例：アレルギー、特別なイベント、キッズチェアなど',
    res_btn_sms: 'SMSで予約を送信する',
    res_alert_fields_required: '必須項目をすべて入力してください。',
    res_alert_closed_day: '当店は日曜・月曜は定休日です。別の日付をお選びください。',

    menu_nav_plats: 'アラカルト料理',
    menu_nav_menus: 'セットメニュー',
    menu_nav_reservation: 'ご予約',
    menu_banner_pre: '当店の',
    menu_banner_em: 'メニュー',
    menu_loading: 'メニューを読み込み中…',
    menu_ref_singular: '点',
    menu_ref_plural: '点',
    menu_miso_note: 'すべてのセットメニューには、キャベツサラダと味噌汁が付きます',
    menu_empty_state: '現在、このカテゴリーに料理はありません。',
    menu_bottom_plats: '料理',
    menu_bottom_menus: 'セット',
    menu_bottom_menu: 'メニュー',
    menu_bottom_reserver: '予約',
    menu_bottom_call: '電話',
    menu_home_title: 'トップページ',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · 火〜土曜営業',

    plats_banner_default: 'アラカルト料理',
    plats_banner_fallback: '当店のメニュー',
    menus_banner_default: 'セットメニュー',
    menus_banner_fallback: '当店のメニュー',
    california_banner_default: 'カリフォルニア',

    fav_back: '← メニューに戻る',
    fav_title: 'お気に入り',
    fav_empty: 'まだお気に入りの商品がありません。お好きな料理をクリックしてお気に入りに追加できます。もう一度クリックすると解除されます。',

    conn_title: 'ログイン',
    conn_email_ph: 'メールアドレス',
    conn_password_ph: 'パスワード',
    conn_btn_login: 'ログインする',
    conn_error: 'ログイン情報が正しくありません。',
    conn_btn_home: 'トップページ',

    info_eyebrow: 'お知らせ',

    legal_title: '法的表示',
    legal_s1_title: '1 - サイト運営者情報',
    legal_s1_intro: 'デジタル経済における信頼に関する2004年6月21日付フランス法律第2004-575号第6条に基づき、ウェブサイト <strong>https://www.bamboosushi.fr/</strong> の利用者に対し、その制作および運営に関わる各関係者の身元を以下の通り明示します：',
    legal_s1_li_owner: '<strong>運営会社：</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>連絡先：</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>住所：</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI（フランス）',
    legal_s1_li_id: '<strong>登記情報：</strong> 資本金3,500ユーロの有限会社（SARL）－ SIREN：509 081 790 － RCS：Albi B 509 081 790',
    legal_s1_li_director: '<strong>発行責任者：</strong> Samphal Buth 氏',
    legal_s1_li_host: '<strong>サーバー提供者：</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043, アメリカ合衆国',
    legal_s2_title: '2 - 知的財産権および著作権侵害について',
    legal_s2_p: 'SARL BAMBOO SUSHI は、本サイト上でアクセス可能なすべての要素（文章、画像、グラフィック、ロゴ、動画、構成、アイコン、音声など）に関する知的財産権および使用権を有しています。事前の書面による許可なく、サイトの要素の全部または一部を複製、表示、改変、公開、翻案することは禁止されています。無断利用は著作権侵害とみなされ、知的財産法第L.335-2条以下の規定に従って法的措置の対象となります。',
    legal_s3_title: '3 - 責任の制限',
    legal_s3_p: 'SARL BAMBOO SUSHI は、本サイトへのアクセス時に利用者の機器に生じた直接的または間接的な損害について責任を負いません。掲載されている情報の利用に関しても一切の責任を負わないものとします。インタラクティブなスペースは監視される場合があります。違法なコンテンツが確認された場合、当社は予告なくこれを削除し、投稿者に対して法的措置を講じる権利を留保します。',
    legal_s4_title: '4 - 個人情報保護（CNIL）について',
    legal_s4_p1: '本サイトは、利用者が自由に入力するフォームを通じてのみ個人情報を収集します。収集されたデータは、利用者の同意がある場合に限り、案内、見積もり、情報の送付のために使用されます。',
    legal_s4_p2: '1978年1月6日付フランス情報処理・自由法第78-17号および一般データ保護規則（GDPR）に基づき、利用者は自己のデータへのアクセス権、訂正権、削除権、異議申立権を有しており、以下の宛先に申請することで行使できます：BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI（フランス）。',
    legal_s4_p3: '来訪状況を測定する目的で、匿名化されたデータに基づく統計分析が行われる場合があります。',
    legal_s5_title: '5 - リンクおよびクッキーについて',
    legal_s5_p: '本サイトには他サイトへのリンクが含まれる場合があります。BAMBOO SUSHI は、これら外部コンテンツについて一切の責任を負いません。閲覧中、お使いのコンピューターにクッキーが保存される場合があります。これらのクッキーは統計目的のみに使用され、利用者の同意なく個人情報を保存することはありません。クッキーの利用は、ブラウザの設定から拒否することができます。クッキーの保存期間は最長13ヶ月です。',
    legal_s6_title: '6 - 準拠法および管轄裁判所について',
    legal_s6_p: 'ウェブサイト <strong>https://www.bamboosushi.fr/</strong> の利用に関するいかなる紛争もフランス法に準拠するものとします。法律上認められない場合を除き、Albi の管轄裁判所が専属的な管轄権を有します。',
    legal_s7_title: '7 - プライバシーポリシー',
    legal_s7_intro: 'BAMBOO SUSHI は、2018年5月25日より施行されている一般データ保護規則（GDPR）に従い、お客様の個人情報の保護とプライバシーの尊重を重要視しています。',
    legal_s7_collecte_label: '個人情報の収集：',
    legal_s7_collecte_text: '本サイト上でお客様が送信される可能性のある個人情報（フォーム、会員専用ページ、お問い合わせなど）は、BAMBOO SUSHI が提供するサービスの範囲内でのみ使用されます。お客様の明確な同意なしに、第三者への販売や提供は一切行いません。',
    legal_s7_finalites_label: '利用目的：',
    legal_s7_finalites_text: 'これらのデータは以下の目的で収集されます：',
    legal_s7_finalites_li1: 'ご依頼やご注文に関してお客様にご連絡するため、',
    legal_s7_finalites_li2: 'お客様アカウントを管理するため、',
    legal_s7_finalites_li3: 'ご同意いただいた場合に最新情報をお知らせするため、',
    legal_s7_finalites_li4: 'サイトのサービスが正常に機能するようにするため。',
    legal_s7_conservation_label: 'データの保存期間：',
    legal_s7_conservation_text: 'データは、収集目的の達成に必要な期間、適用法令を遵守した上で保存されます。',
    legal_s7_droits_label: 'お客様の権利：',
    legal_s7_droits_text: 'GDPRに基づき、お客様はご自身のデータへのアクセス権、訂正権、削除権、データポータビリティ権、および処理への異議申立権・制限権を有しています。これらの権利を行使される場合は、以下までご連絡ください：',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI（フランス）',
  },

  zh: {
    nav_home: '首页',
    nav_menu: '菜单',
    nav_infos: '信息',
    nav_reservation: '预订',
    nav_notre_carte: '我们的菜单',
    nav_plats_a_la_carte: '单点菜品',
    nav_menus_formules: '套餐组合',
    nav_no_product: '该分类暂无商品。',
    flyer_enter_site: '进入网站',
    tagline_restaurant: '日本料理餐厅·阿尔比',

    hero_intro: '在阿尔比市中心恭候您的光临',
    hero_title_line1: '寿司、刺身、',
    hero_title_line2: '烤鸡串及其他日本料理',
    hero_reservation_link: '预订',

    footer_desc: '在阿尔比市中心，使用每日精选新鲜食材，为您呈现正宗日本料理。',
    footer_facebook_aria: 'Facebook Bamboo-Sushi Albi',
    footer_takeaway_aria: '外带',
    footer_hours_label: '营业时间',
    footer_days_tue_thu: '周二至周四',
    footer_days_fri: '周五',
    footer_days_sat: '周六',
    footer_days_sun_mon: '周日、周一',
    footer_closed: '休息',
    footer_alert_closed_lunch: '周五、周六午市休息',
    footer_note_hours: '营业时间在学校假期及公众假期期间可能会有所变动。',
    footer_contact_label: '联系方式',
    footer_legal_label: '法律信息',
    footer_link_mentions: '法律声明',
    footer_link_confidentialite: '隐私政策',
    footer_link_cookies: '链接与Cookie',
    footer_link_espace_prive: '私人空间',
    footer_copyright: '© {year} Bamboo Sushi – 阿尔比日本料理餐厅。保留所有权利。',
    footer_bar_confidentialite: '隐私',
    footer_bar_cookies: 'Cookie',

    b3_eyebrow_find_us: '如何找到我们',
    b3_title_info: '餐厅',
    b3_title_info_em: '信息',
    b3_follow_us: '关注我们',
    b3_takeaway: '外带',
    b3_address_label: '地址',
    b3_hours_label: '营业时间',
    b3_days_open: '周二至周六营业',
    b3_lunch: '午餐',
    b3_dinner: '晚餐',
    b3_eyebrow_clients: '顾客评价',
    b3_title_avis: '评价',
    b3_title_avis_em: 'Google',
    b3_reviews_based_on: '基于441条Google评价',
    b3_review1_text: '每次来都是一种享受！从未失望：新鲜度、卫生、员工的热情……一切都很完美。毫无疑问是附近最好的寿司餐厅。',
    b3_review1_date: '7个月前',
    b3_review2_text: '鱼的品质从未让人失望。如果不知道点什么，推荐尝试便当。有好几道非常美味的菜品可供选择。',
    b3_review2_date: '2年前',
    b3_review3_text: '拉面（外带）非常美味！加州剑鱼特色卷简直一流！性价比也非常出色，我百分之百推荐。',
    b3_review3_date: '1年前',

    b5_quote: '"每一道菜都是一种<em>用心</em>——在<em>新鲜食材</em>、<em>丰盛</em>的分量与<em>细腻风味</em>之间取得完美平衡。"',
    b5_stat1_label: '新鲜鱼类·每日进货',
    b5_stat2_label: '经验年限',
    b5_stat3_label: '菜单创新品类',
    b5_stat4_label: 'Google评分·441条评价',
    b5_prev: '上一张',
    b5_next: '下一张',
    b5_slide1_label: '龙卷',
    b5_slide2_label: '蜘蛛卷',
    b5_slide3_label: '彩虹卷',
    b5_slide4_label: '火山卷',
    b5_slide5_label: '热带风情卷',
    b5_slide6_label: '加州三文鱼牛油果卷',
    b5_slide7_label: '三文鱼、牛油果、奶油芝士',
    b5_slide8_label: '什锦散寿司',

    res_eyebrow: '预订',
    res_title: '预订',
    res_title_em: '一张餐桌',
    res_label_nom: '姓名',
    res_placeholder_nom: '您的姓名',
    res_label_personnes: '人数',
    res_placeholder_personnes: '例如：2',
    res_label_date: '期望日期',
    res_hint_days: '周二至周六营业·周日、周一休息',
    res_ferme_warn: '本日餐厅休息——请选择其他日期。',
    res_label_heure: '期望时间',
    res_choose_heure: '请选择时间',
    res_note_required: '带<strong>*</strong>号的字段为必填项，请在发送预订前填写完整',
    res_label_message: '留言',
    res_placeholder_message: '例如：过敏信息、特殊场合、儿童座椅需求等',
    res_btn_sms: '通过短信发送预订',
    res_alert_fields_required: '请填写所有必填字段。',
    res_alert_closed_day: '餐厅周日和周一休息，请选择其他日期。',

    menu_nav_plats: '单点菜品',
    menu_nav_menus: '套餐组合',
    menu_nav_reservation: '预订',
    menu_banner_pre: '我们的',
    menu_banner_em: '菜单',
    menu_loading: '菜单加载中…',
    menu_ref_singular: '项',
    menu_ref_plural: '项',
    menu_miso_note: '所有套餐均配有卷心菜沙拉和味噌汤',
    menu_empty_state: '该分类目前暂无菜品。',
    menu_bottom_plats: '菜品',
    menu_bottom_menus: '套餐',
    menu_bottom_menu: '菜单',
    menu_bottom_reserver: '预订',
    menu_bottom_call: '致电',
    menu_home_title: '首页',
    menu_footer_info: '40 rue Dr. Laurent Camboulives · 81000 Albi · 周二至周六营业',

    plats_banner_default: '单点菜品',
    plats_banner_fallback: '我们的菜单',
    menus_banner_default: '套餐',
    menus_banner_fallback: '我们的菜单',
    california_banner_default: '加州卷',

    fav_back: '← 返回菜单',
    fav_title: '我的收藏',
    fav_empty: '暂无收藏的商品。点击您喜欢的菜品即可添加到收藏，再次点击可取消收藏。',

    conn_title: '登录',
    conn_email_ph: '电子邮箱',
    conn_password_ph: '密码',
    conn_btn_login: '登录',
    conn_error: '登录信息无效。',
    conn_btn_home: '首页',

    info_eyebrow: '信息',

    legal_title: '法律声明',
    legal_s1_title: '1 - 网站发布者',
    legal_s1_intro: '根据2004年6月21日关于数字经济信任的法国第2004-575号法律第6条规定，现向网站 <strong>https://www.bamboosushi.fr/</strong> 的用户告知参与本网站建设与维护的各相关方身份信息如下：',
    legal_s1_li_owner: '<strong>所有者：</strong> SARL BAMBOO SUSHI',
    legal_s1_li_contact: '<strong>联系方式：</strong> samphal81@gmail.com / 05 63 54 66 09',
    legal_s1_li_address: '<strong>地址：</strong> 40 Rue Docteur Laurent Camboulives, 81000 ALBI，法国',
    legal_s1_li_id: '<strong>企业信息：</strong> 注册资本3,500欧元的有限责任公司（SARL）——SIREN：509 081 790——RCS：Albi B 509 081 790',
    legal_s1_li_director: '<strong>发布负责人：</strong> Samphal Buth 先生',
    legal_s1_li_host: '<strong>托管服务商：</strong> Googleplex – Google World Headquarters, 1600 Amphitheatre Parkway, Mountain View, CA 94043，美国',
    legal_s2_title: '2 - 知识产权与侵权行为',
    legal_s2_p: 'SARL BAMBOO SUSHI 拥有本网站上所有可访问内容（文本、图片、图形、标志、视频、结构设计、图标、音效等）的知识产权及使用权。未经事先书面授权，禁止对网站内容的全部或部分进行复制、展示、修改、发布或改编。任何未经授权的使用行为将被视为侵权，并将依据法国知识产权法典第L.335-2条及后续条款予以追究。',
    legal_s3_title: '3 - 责任限制',
    legal_s3_p: 'SARL BAMBOO SUSHI 对用户在访问本网站过程中因其设备产生的直接或间接损害不承担责任。对于网站所提供信息的使用，本公司不承担任何责任。互动区域可能会受到内容审核。如发现违法内容，本公司保留在不预先通知的情况下将其删除并对相关作者追究法律责任的权利。',
    legal_s4_title: '4 - 个人数据管理（CNIL）',
    legal_s4_p1: '本网站仅通过用户自愿填写的表单收集个人信息。相关数据仅在获得您同意的情况下用于向您发送信函、报价或相关信息。',
    legal_s4_p2: '根据1978年1月6日法国第78-17号《信息与自由法》及《通用数据保护条例》（GDPR），您有权访问、更正、删除您的个人数据并对其处理提出异议，只需向以下地址提出申请即可：BAMBOO SUSHI – 40 Rue Docteur Camboulives, 81000 ALBI，法国。',
    legal_s4_p3: '为衡量网站访问情况，可能会对匿名化数据进行统计分析。',
    legal_s5_title: '5 - 超链接与Cookie',
    legal_s5_p: '本网站可能包含指向其他网站的链接。BAMBOO SUSHI 对该等外部内容不承担任何责任。在浏览过程中，您的电脑上可能会被安装Cookie。这些Cookie仅用于统计分析，未经您同意不会存储任何个人信息。您可以通过浏览器设置拒绝使用Cookie。Cookie的保留期限最长为13个月。',
    legal_s6_title: '6 - 适用法律与司法管辖',
    legal_s6_p: '与网站 <strong>https://www.bamboosushi.fr/</strong> 使用相关的任何争议均适用法国法律。除法律另有规定外，由Albi有管辖权的法院专属管辖。',
    legal_s7_title: '7 - 隐私政策',
    legal_s7_intro: 'BAMBOO SUSHI 高度重视对您个人数据的保护及对您隐私的尊重，并遵守自2018年5月25日起生效的《通用数据保护条例》（GDPR）。',
    legal_s7_collecte_label: '个人数据的收集：',
    legal_s7_collecte_text: '您在本网站上可能提交的个人数据（表单、客户专区、联系请求等）仅在BAMBOO SUSHI提供的服务范围内使用，未经您明确同意，不会转售或转让给第三方。',
    legal_s7_finalites_label: '处理目的：',
    legal_s7_finalites_text: '收集这些数据是为了：',
    legal_s7_finalites_li1: '就您的请求或订单与您取得联系，',
    legal_s7_finalites_li2: '管理您的客户账户，',
    legal_s7_finalites_li3: '在您同意的情况下，向您告知我们的最新动态，',
    legal_s7_finalites_li4: '确保网站服务的正常运行。',
    legal_s7_conservation_label: '数据保留：',
    legal_s7_conservation_text: '数据将根据收集目的所需的期限予以保留，并遵守现行法规。',
    legal_s7_droits_label: '您的权利：',
    legal_s7_droits_text: '根据GDPR，您有权访问、更正、删除及移转您的数据，并有权对数据处理提出异议或要求限制处理。如需行使上述权利，请通过以下方式与我们联系：',
    legal_s7_li_email: '📩 samphal81@gmail.com',
    legal_s7_li_address: '📍 BAMBOO SUSHI – 40 Rue Docteur Laurent Camboulives, 81000 ALBI，法国',
  },
}

// ── Locale globale du site (singleton) ───────────────────────────────────────
const STORAGE_KEY = 'bs_lang'

function detectLocale() {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved && translations[saved]) return saved
  // Pas de détection automatique via navigator.language : Googlebot (et les
  // robots d'indexation en général) n'ont pas une langue "française", donc
  // le site se faisait indexer/afficher en anglais dans les résultats Google.
  // Le français reste la langue par défaut tant que le visiteur n'a pas
  // choisi lui-même une langue via le sélecteur.
  return 'fr'
}

const locale = ref(detectLocale())

export function useLocale() {
  function t(key, vars = {}) {
    let str = translations[locale.value]?.[key] ?? translations.fr[key] ?? key
    for (const [k, v] of Object.entries(vars)) str = str.replace(`{${k}}`, v)
    return str
  }
  function tCat(index, field) {
    return CATEGORIES[index]?.[locale.value]?.[field] ?? CATEGORIES[index]?.fr?.[field] ?? index
  }
  function setLocale(l) {
    locale.value = l
    localStorage.setItem(STORAGE_KEY, l)
  }
  return { locale, t, tCat, setLocale }
}
